import React from "react"

import { ajaxGet, ajaxPost } from "../ajax"

class CashPayoutPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {isFocused: false}
  }

  handleBackgroundClick = (e) => {
    if (e.target !== e.currentTarget) return
    if (this.state.isFocused) {
      this.amountInput.blur()
      this.reasonInput.blur()
    } else {
      this.props.onCancel()
    }
  }

  handleSubmit = () => {
    this.props.onCancel()
    const amount = this.props.amount
    if (!amount) return
    const data = {cashPayout: {amount: amount, reason: this.props.reason, date: this.props.date}}
    ajaxPost('/admins/cash_payouts', data)
      .then(response => { if (response.ok) Turbolinks.visit() })
  }

  handleFocus = (e) => {
    clearTimeout(this.timer)
    this.setState({isFocused: true})
  }

  handleBlur = (e) => {
    this.timer = setTimeout(() => this.setState({isFocused: false}), 500)
  }

  render() {
    const style = this.props.isActive ? {left: "0", position: "relative"} : {left: "100%"}
    if (this.props.isActive) {
      $("#container").addClass("blurred")
    } else {
      $("#container").removeClass("blurred")
    }
    return (
      <div className="cash-payout-panel" onClick={this.handleBackgroundClick} style={style}>
        <div className="cash-payout-panel__content" onClick={this.handleContentClick}>
          <div className="cash-payout-panel__amount">
            $
            <input type="number" min="0" step="0.01" placeholder="0.00" name="amount"
              onChange={this.props.onChange}
              value={this.props.amount ? this.props.amount : ""}
              ref={e => this.amountInput = e}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
            />
          </div>
          <div>Enter Payout Amount</div>
          <textarea placeholder="Reason" name="reason"
            onChange={this.props.onChange}
            value={this.props.reason}
            ref={e => this.reasonInput = e}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
          />
          <button disabled={!this.props.isActive} onClick={this.handleSubmit}>Done</button>
        </div>
      </div>
    )
  }
}

export default CashPayoutPanel
